import React from "react";

interface AppsIconProps {
  size?: number;
  color?: string;
}

export default function AppsIcon({ size = 16, color = "#666" }: AppsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect x="1" y="1" width="3" height="3" rx="1" fill={color} />
      <rect x="6" y="1" width="3" height="3" rx="1" fill={color} />
      <rect x="11" y="1" width="3" height="3" rx="1" fill={color} />
      <rect x="1" y="6" width="3" height="3" rx="1" fill={color} />
      <rect x="6" y="6" width="3" height="3" rx="1" fill={color} />
      <rect x="11" y="6" width="3" height="3" rx="1" fill={color} />
      <rect x="1" y="11" width="3" height="3" rx="1" fill={color} />
      <rect x="6" y="11" width="3" height="3" rx="1" fill={color} />
      <rect x="11" y="11" width="3" height="3" rx="1" fill={color} />
    </svg>
  );
}